import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/search-redesign.svg'
import _imports_1 from '@/assets/Sun.svg'
import _imports_2 from '@/assets/arrow-left.svg'
import _imports_3 from '@/assets/arrow-right.svg'
import _imports_4 from '@/assets/return-arrow.svg'
import _imports_5 from '@/assets/Calendar_Week.svg'
import _imports_6 from '@/assets/File_Check.svg'
import _imports_7 from '@/assets/Clipboard_Check.svg'
import _imports_8 from '@/assets/Log_Out.svg'


const _hoisted_1 = { class: "flex flex-col gap-3 w-full pb-3 pt-5" }
const _hoisted_2 = ["placeholder", "value"]
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-base font-normal text-primary-text-color" }
const _hoisted_5 = {
  key: 1,
  class: "w-full"
}
const _hoisted_6 = {
  key: 0,
  class: "w-full flex items-center gap-[6px] py-[8px] px-2 rounded-[7px] bg-white"
}
const _hoisted_7 = { class: "text-base font-normal text-primary-text-color" }
const _hoisted_8 = {
  key: 1,
  class: "w-full flex items-center gap-[6px] py-[8px] px-2 rounded-[7px] bg-white"
}
const _hoisted_9 = { class: "flex items-center w-full" }
const _hoisted_10 = { class: "text-base font-normal text-primary-text-color" }
const _hoisted_11 = {
  key: 1,
  class: "w-full"
}
const _hoisted_12 = {
  key: 0,
  class: "w-full flex items-center gap-[6px] py-[8px] px-2 rounded-[7px] bg-white"
}
const _hoisted_13 = { class: "text-base font-normal text-primary-text-color" }
const _hoisted_14 = {
  key: 1,
  class: "flex items-center gap-[6px] py-[8px] px-2 rounded-[7px] bg-white"
}
const _hoisted_15 = { class: "text-base" }
const _hoisted_16 = { class: "text-base font-normal text-primary-text-color" }
const _hoisted_17 = { class: "text-base font-normal text-primary-text-color" }
const _hoisted_18 = { class: "text-base font-normal text-primary-text-color" }

import { useUserStore } from "@/stores/user";
import { ref } from "vue";
import router from "@/router";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  isTodayNavigationActive: boolean;
  todayDatePicker: boolean;
  isWeekNavigationActive: boolean;
  weekDatePicker: boolean;
  selectedDate: Date;
  selectedStartDate: Date;
  selectedEndDate: Date;
  searchQuery: string;
  isLoading: boolean;
  activeFilter: string;
};

type Emits = {
  (event: "goToPreviousDay"): void;
  (event: "goToNextDay"): void;
  (event: "resetToToday"): void;
  (event: "goToPreviousWeek"): void;
  (event: "goToNextWeek"): void;
  (event: "resetToThisWeek"): void;
  (event: "getAllProjects"): void;
  (event: "toggleFilterMenu"): void;
  (event: "setActiveFilter", filter: string): void;
  (event: "onChangeSearch", searchQuery: string): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'MobileMenu',
  props: {
    isTodayNavigationActive: { type: Boolean },
    todayDatePicker: { type: Boolean },
    isWeekNavigationActive: { type: Boolean },
    weekDatePicker: { type: Boolean },
    selectedDate: {},
    selectedStartDate: {},
    selectedEndDate: {},
    searchQuery: {},
    isLoading: { type: Boolean },
    activeFilter: {}
  },
  emits: ["goToPreviousDay", "goToNextDay", "resetToToday", "goToPreviousWeek", "goToNextWeek", "resetToThisWeek", "getAllProjects", "toggleFilterMenu", "setActiveFilter", "onChangeSearch"],
  setup(__props: any) {





const isSearchFocused = ref(false);
const logout = () => {
  const userStore = useUserStore();
  userStore.logout();
  router.push("/login");
};
const { t } = useTranslate();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: _normalizeClass(["w-full h-[40px] rounded-primary-radius px-[10px] border border-[#A7A5AE] bg-transparent flex items-center gap-1 mb-3", `${isSearchFocused.value ? 'bg-white ' : ''}`])
    }, [
      _cache[21] || (_cache[21] = _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "w-4 h-4",
          src: _imports_0,
          alt: "Search"
        })
      ], -1)),
      _createElementVNode("input", {
        class: "w-full bg-transparent outline-none text-sm font-normal text-[#898790] placeholder:text-[#898790]",
        type: "text",
        placeholder: 
          isSearchFocused.value
            ? _unref(t)('home.project_name').value
            : _unref(t)('home.search').value
        ,
        value: __props.searchQuery,
        onInput: _cache[0] || (_cache[0] = (event)=>_ctx.$emit('onChangeSearch',event.target.value)),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (isSearchFocused.value = true)),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (isSearchFocused.value = false))
      }, null, 40, _hoisted_2)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      (!__props.isTodayNavigationActive)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('setActiveFilter', 'today'))),
            id: "today",
            class: "flex gap-1 w-full items-center p-2 cursor-pointer bg-[#d3d1cd] rounded-md hover:bg-white duration-300"
          }, [
            _cache[22] || (_cache[22] = _createElementVNode("img", {
              src: _imports_1,
              alt: "Sun icon"
            }, null, -1)),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("home.today")), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.isTodayNavigationActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!__props.todayDatePicker)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", {
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('goToPreviousDay')), ["stop"])),
                    class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                  }, [...(_cache[23] || (_cache[23] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))]),
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('setActiveFilter', 'today')))
                  }, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("home.today")), 1)
                  ]),
                  _createElementVNode("span", {
                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$emit('goToNextDay')), ["stop"])),
                    class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                  }, [...(_cache[24] || (_cache[24] = [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))])
                ]))
              : _createCommentVNode("", true),
            (__props.todayDatePicker)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('resetToToday'))),
                    class: "w-4 h-4 rounded"
                  }, [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("img", {
                      src: _imports_4,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))]),
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('setActiveFilter', 'today'))),
                    id: "today",
                    class: "flex cursor-pointer"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(__props.selectedDate.toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                })), 1)
                  ]),
                  _createElementVNode("span", {
                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.$emit('goToPreviousDay')), ["stop"])),
                    class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                  }, [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))]),
                  _createElementVNode("span", {
                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.$emit('goToNextDay')), ["stop"])),
                    class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                  }, [...(_cache[27] || (_cache[27] = [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (!__props.isWeekNavigationActive)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('setActiveFilter', 'week'))),
            id: "week",
            class: "w-full flex gap-1 items-center p-2 cursor-pointer bg-[#d3d1cd] rounded-md hover:bg-white duration-300"
          }, [
            _cache[28] || (_cache[28] = _createElementVNode("img", {
              src: _imports_5,
              alt: "Sun icon"
            }, null, -1)),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("home.this_week")), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.isWeekNavigationActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (!__props.weekDatePicker)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("span", {
                    onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.$emit('goToPreviousWeek')), ["stop"])),
                    class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                  }, [...(_cache[29] || (_cache[29] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))]),
                  _createElementVNode("button", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('setActiveFilter', 'week')))
                  }, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)("home.this_week")), 1)
                  ]),
                  _createElementVNode("span", {
                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.$emit('goToNextWeek')), ["stop"])),
                    class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                  }, [...(_cache[30] || (_cache[30] = [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))])
                ]))
              : _createCommentVNode("", true),
            (__props.weekDatePicker)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("button", {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('resetToThisWeek'))),
                    class: "w-4 h-4 rounded"
                  }, [...(_cache[31] || (_cache[31] = [
                    _createElementVNode("img", {
                      src: _imports_4,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))]),
                  _createElementVNode("button", {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('setActiveFilter', 'week'))),
                    id: "week",
                    class: "flex cursor-pointer"
                  }, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(__props.selectedStartDate.toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                })) + " - " + _toDisplayString(__props.selectedEndDate.toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                })), 1)
                  ]),
                  _createElementVNode("span", {
                    onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.$emit('goToPreviousWeek')), ["stop"])),
                    class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                  }, [...(_cache[32] || (_cache[32] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))]),
                  _createElementVNode("span", {
                    onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.$emit('goToNextWeek')), ["stop"])),
                    class: "cursor-pointer w-4 h-4 flex items-center justify-center"
                  }, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "Return arrow"
                    }, null, -1)
                  ]))])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('setActiveFilter', 'abnahme'))),
      id: "abnahme",
      class: _normalizeClass(["flex gap-1 items-center p-2 cursor-pointer rounded-md hover:bg-white duration-300", __props.activeFilter === 'abnahme' ? 'bg-white' : 'bg-[#d3d1cd]'])
    }, [
      _cache[34] || (_cache[34] = _createElementVNode("img", {
        src: _imports_6,
        alt: "Sun icon"
      }, null, -1)),
      _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)("home.abnahme_ready")), 1)
    ], 2),
    _createElementVNode("button", {
      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('setActiveFilter', 'qc'))),
      id: "qc",
      class: _normalizeClass(["flex gap-1 items-center p-2 cursor-pointer rounded-md hover:bg-white duration-300", __props.activeFilter === 'qc' ? 'bg-white' : 'bg-[#d3d1cd]'])
    }, [
      _cache[35] || (_cache[35] = _createElementVNode("img", {
        src: _imports_7,
        alt: "Sun icon"
      }, null, -1)),
      _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)("home.qc_ready")), 1)
    ], 2),
    _createElementVNode("button", {
      onClick: logout,
      id: "qc",
      class: "flex gap-1 items-center p-2 cursor-pointer rounded-md hover:bg-white duration-300 mt-5"
    }, [
      _cache[36] || (_cache[36] = _createElementVNode("img", {
        src: _imports_8,
        alt: "Sun icon"
      }, null, -1)),
      _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)("global.log_out")), 1)
    ])
  ]))
}
}

})